import type { DiscoveryContentTypeConfig } from '@terra/shared-asset-processing';
import {
  normalizeMimeKey,
  resolveDiscoveryContentTypes,
} from '@terra/shared-asset-processing';

const serializeDiscoveryContentTypes = (
  configs: readonly DiscoveryContentTypeConfig[],
): string =>
  JSON.stringify(
    configs.map((config) => ({
      mimeType: normalizeMimeKey(config.mimeType),
      description: config.description ?? null,
      origin: config.origin,
      crawlerEnabled: config.crawlerEnabled,
      torchTrackingEnabled: config.torchTrackingEnabled,
    })),
  );

export const areDiscoveryContentTypesEqual = (
  left?: readonly DiscoveryContentTypeConfig[] | null,
  right?: readonly DiscoveryContentTypeConfig[] | null,
): boolean =>
  serializeDiscoveryContentTypes(resolveDiscoveryContentTypes(left)) ===
  serializeDiscoveryContentTypes(resolveDiscoveryContentTypes(right));
